<template>
  <el-container class="layout-container">
    <el-main class="layout-main">
      <div class="bg">
        <div class="layout-header slide-in-top">
          <div class="layout-sitename">
            <div class="site-name">{{ siteName }}  {{ pageConfig.LandLayerShow }}</div>
          </div>
        </div>
      </div>
      <template v-if="pageConfig">
        <div class="leftTool">
          <div style="display: flex; margin-bottom: 10px">
            <vue-treeselect
              class="treeselect-normal icontreeSelect"
              v-model="query.regionId"
              noResultsText="无匹配数据"
              noChildrenText="无可用子选项"
              noOptionsText="无可用选项"
              :options="regions"
              :clearable="false"
              style="margin-right: 10px"
              :searchable="true"
              :show-count="true"
              placeholder="请选择区域"
              @select="handleSelect"
            />
            <vue-treeselect
              class="treeselect-normal icontreeSelect projectSelect"
              v-model="projectValue"
              noResultsText="无匹配数据"
              noChildrenText="无可用子选项"
              noOptionsText="无可用选项"
              :options="projectList"
              :clearable="false"
              :searchable="true"
              :show-count="true"
              placeholder="请选择项目"
              @select="projectchange"
            />
            <vue-treeselect
              v-if="pageConfig.cropSelectShow"
              class="treeselect-normal icontreeSelect cropSelect"
              v-model="cropIdValue"
              noResultsText="无匹配数据"
              noChildrenText="无可用子选项"
              noOptionsText="无可用选项"
              :options="allfeatures"
              :clearable="false"
              :searchable="true"
              :show-count="true"
              placeholder="请选择作物"
              @select="cropIdchange"
            />
          </div>
          <div>
            <el-date-picker
              v-if="pageConfig.datePickerShow"
              v-model="sreachTimeArr"
              class="green_date_picker"
              type="daterange"
              value-format="yyyy-MM-dd"
              @change="getTimeListFun"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
              style="width: 240px"
            />
          </div>
        </div>
        <layoutMenu :newMenus="newMenus" @onMenuClick="onMenuClick" />
        <layout-info :username="username" />
        <el-form
          class="search-form"
          :model="filtrate"
          inline
          size="small"
          v-if="pageConfig.introductionShow"
        >
          <el-form-item class="m-b-n">
            <el-button
              @click="onSearch"
              class="bigbtn"
              v-if="!showProjectDetail"
              >项目简介</el-button
            >
          </el-form-item>
        </el-form>

        <landPopup
          :popupObj="popupObj"
          :closeFun="closeLandDetail"
          :landDetatilPopShow="landDetatilPopShow"
        />

        <introduction
          v-if="pageConfig.introductionShow"
          :projectDetail="projectDetail"
          :showProjectDetail="showProjectDetail"
          :closeFun="
            () => {
              showProjectDetail = false;
            }
          "
        />
        <div class="" style="width: 100%">
          <ol-map
            :timelines="timelines"
            :extent="extent"
            :projectValue="projectValue"
            :legends="legends"
            :gradientLegends="gradientLegends"
            @click="onMapClick"
            @timelineChange="onTimelineChange"
            :unit="pageConfig.unit"
            :toolPosition="{ top: '10%' }"
            :datasetName="pageConfig.title"
            :datasetUnit="pageConfig.datasetUnit"
            :rollerShow="pageConfig.rollerShow"
          >
            <ol-view
              :zoom="14"
              :extent="extent"
              :padding="[20, 0, 20, 0]"
            ></ol-view>

            <ol-layer-tile
              v-if="layerName !== ''"
              name="成果图层"
              :zIndex="8"
              :clip="clip"
            >
              <ol-source-tilewms v-if="layerName !== ''" :layers="layerName" />
            </ol-layer-tile>
            <ol-layer-tile name="地块编号图层" :zIndex="8" ref="numLandLayer" v-if="pageConfig.numLandLayerShow">
              <ol-source-tilewms
              v-if="pageConfig.numLandLayerShow"
                layers="henan:high_field_land"
                styles="henan:land_style"
                :filter="`project_id=${projectValue} and data_date=${dateValue}`"
                :clip="clip"
              />
            </ol-layer-tile>

            <ol-layer-tile name="地块图层" v-if="pageConfig.LandLayerShow" :zIndex="9" ref="landLayer">
              <ol-source-tilewms
              v-if="pageConfig.LandLayerShow"
                layers="henan:high_field_land"
                styles="land_no_mark_style"
                :filter="`project_id=${projectValue} and data_date=${dateValue}`"
                :clip="clip"
              />
            </ol-layer-tile>

            <!-- 地块高亮 -->
            <ol-geom-polygon
              name="highlight"
              :features="highlightObj"
              :zIndex="100"
              :effect="{ stroke: { color: 'red', width: 2 } }"
            />
            <ol-layer-tile name="边界图层" v-if="regionLayerShow" :zIndex="5">
              <ol-source-tilewms
                layers="henan:prod_region"
                styles="land_region_style"
                :filter="`region_id=${regionId} or parent_id=${regionId}`"
              />
            </ol-layer-tile>
            <template #tools>
              <div class="ol-map-tool-group m-t-sm" v-if="sequelId !== ''">
                <div class="ol-map-tool">
                  <el-tooltip
                    class="item"
                    popper-class="my-custom-tooltip"
                    effect="dark"
                    content="表格"
                    placement="left"
                  >
                    <svg-icon
                      icon-name="table"
                      icon-class="ol-map-tool-icon"
                      @click.native="openTableDialog"
                    ></svg-icon>
                  </el-tooltip>
                </div>

                <div class="ol-map-tool">
                  <el-tooltip
                    class="item"
                    popper-class="my-custom-tooltip"
                    effect="dark"
                    content="下载"
                    placement="left"
                  >
                    <svg-icon
                      icon-name="download"
                      icon-class="ol-map-tool-icon"
                      @click.native="onDownload"
                    ></svg-icon>
                  </el-tooltip>
                </div>
              </div>
            </template>
          </ol-map>
        </div>
      </template>
    </el-main>
  </el-container>
</template>

  <script>
import { mapState } from "vuex";
import {
  getAllProduct,
  getAllRegion,
  getAllFeature,
  getAllFeatureList,
  getDicts,
  getPersonal,
  getCode,
  getRemind,
  getAllProductResult,
  getProductResult,
  getResultLandInfo,
  getBoundary,
  getProductFile,
  getFieldProject,
  getFieldProjectPage,
  getDateListPage,
  getLandExtent,
  getLandInfoByCood,
  getLandInfoByLandId,
  getTableData,
  getTimeList,
  getResultTableData,
  getResultEchartsData,
} from "@/api/common";
import { listToTree, findRouteCode } from "@/utils/tools";
import axios from "axios";
import { login } from "@/api/login";
import {
  setCookieWithResidueTime,
  getCookie,
  delCookie,
} from "@/utils/setCookie";
import layoutMenu from "@/components/home/layout-menu";
import layoutInfo from "@/components/home/layout-info";
import introduction from "@/components/home/introduction";


import config from "./config";
export default {
  name: "AppLayout",
  components: {
    layoutMenu,
    layoutInfo,
    introduction,
  },
  computed: {
    ...mapState(["menus"]),
    pageConfig() {
      return config[this.currentMenu];
    },
    projectName() {
      return (
        this.projectList.find((v) => v.id == this.projectValue)?.name || ""
      );
    },
  },
  watch: {},
  mounted() {
    this.init();
    this.onLogin();
  },

  data() {
    return {
      regions: [],
      needRemind: false,
      currentMenu: "",
      showRemind: false,
      reminds: [],
      siteName: process.env.VUE_APP_TITLE,
      screen: process.env.VUE_APP_SCREEN === "true",
      username: "",
      newMenus: [],
      query: {
        productId: "",
        regionId: "",
      },
      formData: {
        username: "",
        password: "",
        verify: true,
      },
      menuTimeout: null,
      center: [105.59010302734374, 30.53518298339844],
      extent: [],
      filtrate: {},
      timelines: [],
      legends: [],
      gradientLegends: [],
      layerName: "",
      hdLayerName: "",
      showBarEchart: false,
      showPieEchart: false,
      showTable: false,
      showMassif: false,
      massif: {},
      tableData: [],
      barEchartOption: {},
      pieEchartOption: {},
      cropIdValue: 9999,
      allfeaturesDict: JSON.parse(localStorage.getItem("allfeaturesDict")),
      allfeatures: JSON.parse(localStorage.getItem("allfeatures")),
      filtrateClip: "",
      filtrateExtent: "",
      zone: "",
      clip: "",
      dateValue: "",
      regionId: "",
      // 成果ID
      sequelId: "",
      regionNameLayer: {},
      highlightObj: {},
      overlayerPo: [],
      projectValue: null,
      projectList: [],
      tableList: [],
      dateList: [],
      landDetatilPopShow: false,
      showProjectDetail: false,
      regionLayerShow: false,
      projectDetail: {
        name: "",
        imageUrl: "",
        introdiction: "",
      },
      sreachTimeArr: [],
      popupObj: {
        num: "",
        area: "",
        cropType: "",
        grade: "",
        ownership: "",
        soil: "",
        unit: "",
      },
    };
  },

  methods: {
    //地块管理特有start
    onSearch() {
      if (!this.projectValue) return;
      this.showProjectDetail = !this.showProjectDetail;
      this.showBarEchart = false;
      this.showPieEchart = false;
      this.landDetatilPopShow = false;
      this.showTable = false;
      this.highlightObj = "";
      let obj = this.projectList.find((v) => v.id == this.projectValue);
      this.projectDetail = obj;
    },
    //地块管理特有end
    closeLandDetail() {
      this.landDetatilPopShow = false;
      this.highlightObj = "";
    },
    onMenuClick({ id, code }) {
      this.currentMenu = code;
      this.query.productId = id;
      // this.refreshLayers();
    },
    refreshLayers() {
      //重新设置图层
      switch (this.currentMenu) {
        case "landManage":
          this.$refs.landLayer?.getLayer((layer) => {
            layer.setVisible(false);
          });
          this.$refs.numLandLayer?.getLayer((layer) => {
            layer.setVisible(true);
          });
          break;
        case "nonFarm":
          this.$refs.numLandLayer?.getLayer((layer) => {
            layer.setVisible(false);
          });
          this.$refs.landLayer?.getLayer((layer) => {
            layer.setVisible(true);
          });
          break;
        default:
          break;
      }
    },
    init() {
      //检测客户系统是否过期
      let oldUrl = this.$route.query.oldUrl;
      let cookieToken = this.$route.query.coo;
      if (oldUrl && cookieToken) {
        let baseUrl = oldUrl.substring(0, oldUrl.lastIndexOf("/") + 1);
        localStorage.setItem("oldUrl", baseUrl);
        const timestamp = 30 * 60 * 1000;
        setCookieWithResidueTime("kefuToken", cookieToken, timestamp);
        setTimeout(() => {
          let url = window.location.href;
          let first = url.split("?")[0];
          window.location.href = first;
        }, 100);
      } else {
        let kefuTokenStorage = getCookie("kefuToken");
        if (!kefuTokenStorage) {
          let baseUrl = localStorage.getItem("oldUrl");
          window.location.href = baseUrl + "login.html";
        } else {
          axios({
            method: "get",
            url: "/kuhu/henan/nolog/account/checkUserLogin",
            headers: {
              Accesstoken: kefuTokenStorage,
            },
          }).then((res) => {
            let flag = res.data.flag;
            let data = res.data.data;
            if (flag) {
              this.username = data.personName;
            } else {
              this.username = "";
            }
          });
        }
      }
    },
    async onLogin() {
      // 登录
      const { data } = await login(this.formData);
      if (!data) {
        this.errorTip("用户名或密码错误");
        this.$waiting.hidden();
        return;
      }
      // 设置 token
      localStorage.setItem("token", data.accessToken);
      localStorage.setItem("refreshToken", data.refreshToken);

      // 获取菜单
      let { data: products } = await getAllProduct();
      products = products.filter((item) => item.remark == "land");
      const productTree = listToTree(products);
      let routeName = "";
      let productId = "";
      localStorage.setItem("menus", JSON.stringify(productTree));
      if (productTree[0].children) {
        localStorage.setItem("defaultProductId", productTree[0].children[0].id);
        routeName = productTree[0].children[0].route;
        productId = productTree[0].children[0].id;
      } else {
        localStorage.setItem("defaultProductId", productTree[0].id);
        routeName = productTree[0].route;
        productId = productTree[0].id;
      }
      this.$store.commit("setMenus", productTree);
      let menus = productTree;
      menus.forEach((v) => {
        this.$set(v, "subMenusShow", false);
      });
      this.newMenus = menus;

      //获取字典
      const { data: dicts } = await getDicts({
        pageNo: 1,
        pageSize: 100,
        dictType: "equip_type",
      });
      const equipDictsDict = {};
      dicts.list.forEach((v) => {
        equipDictsDict[v.value] = v.label;
      });

      localStorage.setItem("equipDictsDict", JSON.stringify(equipDictsDict));
      localStorage.setItem("equipDictsArr", JSON.stringify(dicts.list));

      // 获取区域
      const { data: regions } = await getAllRegion();
      const regionsDict = {};
      regions.forEach((item) => {
        item.label = item.name;
        regionsDict[item.id] = item.name;
      });
      const regionTree = listToTree(regions);
      this.regions = regionTree;
      localStorage.setItem("regions", JSON.stringify(regionTree));
      localStorage.setItem("regionsDict", JSON.stringify(regionsDict));
      localStorage.setItem("defaultRegionId", regions[0].id.toString());
      this.$store.commit("setRegions", regionTree);

      //获取所有地物列表
      const { data: featuresList } = await getAllFeatureList({
        code: null,
        name: null,
      });
      const allfeaturesDict = {};
      featuresList.forEach((item) => {
        item.label = item.name;
        allfeaturesDict[item.id] = item.name;
      });
      const allfeatureTree = listToTree(featuresList);
      localStorage.setItem("allfeaturesDict", JSON.stringify(allfeaturesDict));
      localStorage.setItem("allfeatures", JSON.stringify(allfeatureTree));
      // 获取地物
      const { data: features } = await getAllFeature();
      const featuresDict = {};
      features.forEach((item) => {
        item.label = item.name;
        featuresDict[item.id] = item.name;
      });
      const featureTree = listToTree(features);
      localStorage.setItem("featuresDict", JSON.stringify(featuresDict));
      localStorage.setItem("features", JSON.stringify(featureTree));
      if (featureTree[0].children) {
        localStorage.setItem("defaultFeatureId", featureTree[0].children[0].id);
      } else {
        localStorage.setItem("defaultFeatureId", featureTree[0].id);
      }
      this.$store.commit("setFeatures", featureTree);
      //   let code = this.$route.meta.module;
      let code = localStorage.getItem("currentCode");
      let arr1 = {};
      if (code) {
        arr1 = findRouteCode(this.newMenus, code);
      } else {
        arr1 = this.newMenus[0];
      }
      this.currentMenu = arr1.code;
      localStorage.setItem("currentCode", this.currentMenu);
      // this.refreshLayers();
      const query = {
        productId: arr1.id,
        regionId: regions[0].id.toString(),
      };

      if (routeName.startsWith("land")) {
        query.featureId = -1;
      } else if (
        !routeName.startsWith("warning") &&
        !routeName.startsWith("monitor")
      ) {
        query.featureId = featureTree[0].children[0].id;
      }
      this.query = query;
      this.regionId = this.query.regionId;
      localStorage.setItem("query", JSON.stringify(query));
      this.mapInit();
    },

    parseBoxString(boxString) {
      // 使用正则表达式匹配数字
      const regex = /BOX\(([\d.-]+)\s([\d.-]+),\s*([\d.-]+)\s([\d.-]+)\)/;
      const match = boxString.match(regex);

      if (match && match.length === 5) {
        // 将匹配到的字符串转换为浮点数
        return [
          parseFloat(match[1]),
          parseFloat(match[2]),
          parseFloat(match[3]),
          parseFloat(match[4]),
        ];
      } else {
        throw new Error("Invalid BOX string format");
      }
    },
    openTableDialog() {
      if (!this.projectValue) return;
      this.showTable = !this.showTable;
      this.highlightObj = "";
      this.landDetatilPopShow = false;
      this.showProjectDetail = false;
      this.showBarEchart = false;
      this.showPieEchart = false;
      if (this.showTable) {
        this.getTableFun();
      }
    },
    async openEchartsBarDialog() {
      if (!this.projectValue) return;
      this.showBarEchart = !this.showBarEchart;
      this.highlightObj = "";
      this.landDetatilPopShow = false;
      this.showProjectDetail = false;
      this.showTable = false;
      this.showPieEchart = false;
      if (this.showBarEchart) {
        let { data: echartsData } = await getResultTableData({
          id: this.sequelId,
        });
        let data = echartsData.dataset;
        // let newData = [];
        // let obj = {};
        // data.forEach((v) => {
        //   obj[v.dataDate] = [];
        // });
        // for (let k in obj) {
        //   let obj_ = {};
        //   data.forEach((v) => {
        //     if (k == v.dataDate) {
        //       console.log(999);
        //       obj_.dataDate = k;
        //       obj_[v.cropId] = v.area;
        //     }
        //   });
        //   newData.push(obj_);
        // }
        // let cropDict = JSON.parse(localStorage.getItem("featuresDict"));
        // let newDict = {};
        // for (let k in cropDict) {
        //   newDict[cropDict[k]] = k;
        // }
        this.barEchartOption = echarts[this.pageConfig.echart2](
          data,
          this.legends,
          this.pageConfig.pieDict
        );
      }
    },
    async openEchartsPieDialog() {
      if (!this.projectValue) return;
      this.showPieEchart = !this.showPieEchart;
      this.highlightObj = "";
      this.landDetatilPopShow = false;
      this.showBarEchart = false;
      this.showProjectDetail = false;
      this.showTable = false;
      if (this.showPieEchart) {
        let { data: echartsData } = await getResultTableData({
          id: this.sequelId,
        });
        let currentData = echartsData.currentDataset;
        let dataset = echartsData.dataset;
        dataset.forEach((v) => {
          if (
            currentData.resultId == v.resultId &&
            v.dataDate == currentData.dataDate
          ) {
            currentData[v.cropId] = v.area;
          }
        });

        let cropDict = JSON.parse(localStorage.getItem("featuresDict"));
        let newDict = {};
        for (let k in cropDict) {
          newDict[cropDict[k]] = k;
        }
        this.pieEchartOption = echarts[this.pageConfig.echart](
          currentData,
          this.legends,
          this.pageConfig.pieDict
        );
      }
    },

    handleSelect(e) {
      let ex = e.vertexBbox
        .slice(4, -1)
        .split(",")
        .map((item) => item.split(" "))
        .reduce((pre, cur) => pre.concat(cur))
        .map((item) => item * 1);
      this.extent = ex;
      this.regionId = e.id;
      this.closeHighlight();
      this.getFieldProjectPageFun();
      // this.regionLayerShow = true;
    },
    dateChange() {
      this.getLandExtentFun();
      this.closeHighlight();
    },
    closeHighlight() {
      if (this.showBarEchart) {
        this.showBarEchart = false;
      }
      if (this.showPieEchart) {
        this.showPieEchart = false;
      }
      if (this.highlightObj) {
        this.highlightObj = "";
      }
      if (this.landDetatilPopShow) {
        this.landDetatilPopShow = false;
      }
      if (this.showTable) {
        this.showTable = false;
      }
      if (this.showProjectDetail) {
        this.showProjectDetail = false;
      }
    },
    async cropIdchange(item) {
      this.cropIdValue = item.id;
      this.getTimeListFun();
    },
    async projectchange(item) {
      // this.regionLayerShow = false;
      this.projectValue = item.id;
      localStorage.setItem("lastProjectValue", this.projectValue);
      this.getDateTableFun();
      this.closeHighlight();
      this.getTimeListFun();
    },
    async onMapClick({ evt, features, map }) {
      const [lon, lat] = evt.coordinate;
      const { data } = await getLandInfoByCood({ lon, lat });
      this.showEchart = false;
      this.showTable = false;
      if (data) {
        this.landDetatilPopShow = true;
        this.highlightObj = data.bbox;
        this.popupObj = data;
      } else {
        this.highlightObj = "";
        this.landDetatilPopShow = false;
      }
    },

    async onTimelineChange(item) {
      // this.$waiting.show();
      this.sequelId = item.id;
      const details = await getProductResult(item);
      this.dateValue = findClosestDate(
        details.currentDataset.dataDate,
        this.dateList
      );
      this.layerName = details.layer;
      let type = config[this.currentMenu].legendType;
      if (type == "legend") {
        this.legends = details.legends;
      }
      this.setFarmingLegend();
    },

    async onDownload() {
      this.$waiting.show();
      const file = await getProductFile(this.sequelId).finally(() =>
        this.$waiting.hidden()
      );
      createFile(file);
    },
    exportFile() {
      exportExcelFile(
        this.pageConfig.columns,
        this.tableList,
        this.pageConfig.title
      );
    },
    exportEcharts(type) {
      let timeLabel = this.timelines.find(
        (v) => v.id == this.sequelId
      ).productTimeCn;
      if (type == "bar") {
        downloadchart(
          "bar",
          this.barEchartOption,
          this.pageConfig.unit,
          this.pageConfig.title + timeLabel + "数据统计"
        );
      }
      if (type == "pie") {
        downloadchart(
          "pie",
          this.pieEchartOption,
          this.pageConfig.unit,
          this.pageConfig.title + timeLabel + "数据统计"
        );
      }
    },
    noData() {
      this.layerName = "";
      this.legends = [];
      this.gradientLegends = [];
      this.sequelId = "";
      this.nowTimeLinesId = "";
    },
    async getTimeListFun() {
      if (!this.projectValue) {
        this.noData();
        return;
      }
      let startDate = "";
      let endDate = "";
      if (this.sreachTimeArr && this.sreachTimeArr.length > 0) {
        startDate = this.sreachTimeArr[0];
        endDate = this.sreachTimeArr[1];
      }
      let { data: timeList } = await getTimeList({
        productId: this.query.productId,
        projectId: this.projectValue,
        featureId: this.cropIdValue,
        startDate,
        endDate,
      });
      let type = config[this.currentMenu].legendType;
      this.timelines = timeList.list;
      if (timeList.list.length > 0) {
        const details = await getProductResult(timeList.list[0]);
        this.nowTimeLinesId = timeList.list[0].id;
        this.layerName = details.layer;
        if (type == "legend") {
          this.legends = details.legends;
        }
        this.sequelId = timeList.list[0].id;
      } else {
        this.noData();
      }
      this.setFarmingLegend();
    },
    //请求表格图表数据
    async getTableFun() {
      let { data: tableRes } = await getResultTableData({
        id: this.sequelId,
      });
      this.tableList = [];
      let currentData = tableRes.currentDataset;
      let dataset = tableRes.dataset;
      dataset.forEach((v) => {
        if (
          currentData.resultId == v.resultId &&
          v.dataDate == currentData.dataDate
        ) {
          currentData[v.cropId] = v.area;
        }
      });
      // let cropDict = JSON.parse(localStorage.getItem("featuresDict"));
      // this.pageConfig.columns = [];
      // for (let k in currentData) {
      //   let obj = {};
      //   if (cropDict[k]) {
      //     obj.label = cropDict[k];
      //     obj.field = k;
      //     this.pageConfig.columns.push(obj);
      //   }
      // }
      // let fieldArr = this.pageConfig.columns.map((v) => v.field);

      this.tableList.push(currentData);
      // this.tableList = [currentData];
    },
    //请求地图定位数据
    async getLandExtentFun() {
      let result = await getLandExtent({
        projectId: this.projectValue,
        dataDate: this.dateValue,
      });
      const bboxArray = this.parseBoxString(result.data);
      this.extent = bboxArray;
    },
    //请求日期下拉框数据
    async getDateTableFun() {
      let { data: dateRes } = await getDateListPage({
        projectId: this.projectValue,
      });
      this.dateList = dateRes;
      if (this.dateList.length > 0) {
        this.dateValue = this.dateList[0];
      } else {
        this.dateValue = "";
      }
      this.timelines = [];
      dateRes.forEach((v) => {
        this.timelines.push({
          productTimeCn: v,
          id: v,
          thumb: `/wms?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image/png&TRANSPARENT=TRUE&LAYERS=henan:high_field_land&WIDTH=200&HEIGHT=200&STYLES=henan:land_style&CQL_FILTER=project_id=${this.projectValue} and data_date=${this.dateValue}`,
        });
      });
      //if (!this.regionLayerShow) {
      this.getLandExtentFun();
      //}
    },
    //请求项目数据
    async getFieldProjectPageFun() {
      let { data: projectList } = await getFieldProjectPage({
        regionId: this.regionId,
      });
      let oldvalue = localStorage.getItem("lastProjectValue");
      if (projectList.length > 0) {
        let arrs = [];
        projectList.forEach((item) => {
          arrs.push({
            name: item.name,
            id: item.id,
            label: item.name,
            ...item,
          });
        });
        this.projectList = arrs;
        if (this.projectList.length > 0) {
          if (oldvalue) {
            this.projectValue = oldvalue;
          } else {
            this.projectValue = this.projectList[0].id;
            localStorage.setItem("lastProjectValue", this.projectValue);
          }
        } else {
          this.projectValue = null;
          localStorage.setItem("lastProjectValue", "");
        }
        this.getDateTableFun();
        this.regionLayerShow = false;
        // this.getTimeListFun();
        this.projectDetail = projectList[0];
      } else {
        this.projectList = [];
        this.projectValue = null;
        this.dateList = [];
        this.dateValue = "";
        localStorage.setItem("lastProjectValue", "");
        this.timelines = [];
        this.regionLayerShow = true;
        this.layerName = "";
        this.projectDetail = {};

        this.Message({ type: "warning", message: "该区域下没有项目数据" });
      }
    },
    async getAllProductResultFun() {
      console.log("this.query", this.query);

      let productResults = await getAllProductResult(this.query);
      console.log("productResults--productResults", productResults);

      let { data: boundary } = await getBoundary(this.query.regionId);
      this.clip = boundary;
      if (productResults.list.length > 0) {
        const first = productResults.list[0];
        this.sequelId = first.id;
        const productResult = await getProductResult(first);
        this.layerName = productResult.layer;
        this.hdLayerName = productResult.hdLayer;
        this.dataset = productResult.dataset;
        this.legends = productResult.legends;
      }
    },
    async setFarmingLegend() {
      let type = config[this.currentMenu].legendType;
      if (type == "legend") {
        this.gradientLegends = [];
        return;
      }
      console.log("this.sequelId", this.sequelId);

      let { data: tableRes } = await getResultTableData({
        id: this.sequelId,
      });
      let currentData = tableRes.currentDataset;
      let dataset = tableRes.dataset;
      dataset.forEach((v) => {
        if (
          currentData.resultId == v.resultId &&
          v.dataDate == currentData.dataDate
        ) {
          currentData[v.cropId] = v.area;
        }
      });
      this.tableList = [];
      this.tableList.push(currentData);
      if (this.tableList.length < 0) {
        this.gradientLegends = [];
        return;
      }
      let max = this.tableList[0].value2;
      let min = this.tableList[0].value1;

      let colorList = config[this.currentMenu].colorList;
      colorList[0].labelText = max;
      colorList[colorList.length - 1].labelText = min;
      this.gradientLegends = colorList;
      this.legends = [];
    },
    mapInit() {
      this.getAllProductResultFun();
      this.getFieldProjectPageFun();
    },
  },
};
</script>

  <style lang="scss" scoped>
.layout-container {
  height: 100vh;
  // background: url('~@/assets/images/layout/bg01.png') no-repeat 0 0 / cover;
  overflow: hidden;
}

.layout-main {
  position: relative;
  overflow: hidden;
}

.bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  z-index: 2;
  background: url("~@/assets/images/layout/bigbj.png") no-repeat;
  background-size: 100% 100%;
  pointer-events: none;
}

.layout-header {
  position: absolute;
  text-align: center;
  width: 100%;
  height: 70px;
  display: flex;

  z-index: 2;

  .logo {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 15px;
  }

  .layout-sitename {
    margin: 0 auto;
  }

  .site-name {
    font-size: 40px;
    font-weight: 900;
    font-family: AlimamaShuHeiTi, serif;
    letter-spacing: 0.1em;
    background: linear-gradient(180deg, #d2ffee 0%, #e5fff5 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
    margin-top: 10px;
  }
}
</style>
